import {
  myAxios as axios
} from './index'
const serve = "/user-center";

/**
 * 扫码登录重定向
 * @param params
 * @returns {*}
 */
export const openLoginCode = (params) => {
  return axios({
    method: 'get',
    url: `${serve}/ocrWebChat/openLoginCode.ajax`,
    params
  })
}

/**
 * 获取上一次识别和登录信息
 * @param params
 * @returns {*}
 */
export const queryinfo = () => {
  return axios({
    url: `${serve}/ocrWebChat/queryinfo.ajax`,
  })
}

/**
 * web端保存识别结果
 * @param params
 * @returns {*}
 */
export const websendtopc = (params) => {
  return axios({
    url: `${serve}/ocrWebChat/websendtopc.ajax`,
    data: params
  })
}

/**
 * web端退出登录
 * @param params
 * @returns {*}
 */
export const signoutforSession = () => {
  return axios({
    url: `${serve}/ocrWebChat/signoutforSession.ajax`
  })
}